exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Error__error___1sgE6 {\n  color: #d56062;\n  display: block;\n  margin-top: 12px;\n}\n", ""]);

// exports
exports.locals = {
	"error": "Error__error___1sgE6"
};